import CryptoJS from 'crypto-js';

export default function generateProductIdentifiers(name: string): {
    mpn: string,
    sku: string
} {
    const hash = CryptoJS.SHA256(name).toString(CryptoJS.enc.Hex);
    const formattedName = name.replace(/\s+/g, '-').toUpperCase();
    const mpn = `${formattedName}-${hash.substring(0, 8)}`;
    const sku = `SKU-${hash.substring(0, 8)}-${formattedName}`;
    return {mpn, sku};
}
